import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UserAuthService } from '../../../shared/services/user-auth.service';
import { environment } from '../../../../environments/environment';
import { first, Observable } from 'rxjs';
import { ShowAlertsComponent } from '../../../shared/components/show-alerts/show-alerts.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LogService } from '../../../shared/services/log.service';
import { SharedService } from '../../../shared/services/shared.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: false,
})
export class ToolbarComponent extends ShowAlertsComponent implements OnInit {
  @Output() toggleSidenav = new EventEmitter<void>();

  public badgeCount: string = '10';

  username = '';
  email: any;
  roles: any;
  version = environment.version;
  isOperator!: Observable<boolean>;

  constructor(
    public override router: Router,
    public override snackBar: MatSnackBar,
    public override dialog: MatDialog,
    public override logger: LogService,
    private authService: UserAuthService,
    private sharedService: SharedService,
  ) {
    super(router, snackBar, dialog, logger);
    this.isOperator = this.sharedService.showOperatorPage;
  }
  ngOnInit(): void {
    this.isOperator = this.sharedService.showOperatorPage;
    this.authService
      .getUserRoles()
      .pipe(first())
      .subscribe({
        next: (data) => (
          (this.roles = data.role),
          this.authService.setUser(data),
          this.setRoles(data)
        ),
        error: () => console.log('Error loading roles!'),
      });
  }

  getUserInformation() {
    this.authService
      .getCache()
      .pipe(first())
      .subscribe({
        next: (data) => this.setUserSelection(data),
        error: () => console.log('Error loading information!'),
      });
  }

  setUserSelection(data: any) {
    this.authService
      .setUserSelection(data)
      .pipe(first())
      .subscribe({
        next: (data) => console.log('set'),
        error: () => console.log('Error loading information!'),
      });
  }

  setRoles(data: any) {
    this.username = data.firstName + ' ' + data.lastName;
    this.email = data.email;
    this.roles = data.role;
  }

  changeTheme() {
    const body = document.getElementsByTagName('body')[0];
    if (body.classList.contains('dark-theme')) {
      body.classList.remove('dark-theme');
      body.classList.add('light-theme');
    } else {
      body.classList.remove('light-theme');
      body.classList.add('dark-theme');
    }
    return true;
  }

  userProfile() {
    this.router.navigate(['/user/profile']);
  }

  changePassword() {
    this.router.navigate(['/user/changePassword']);
  }

  onLogout() {
    localStorage.clear();
    this.authService.logout();
  }
}
